module.exports = __webpack_public_path__ + "static/media/10-Hearts.c9bce6c1.svg";